import { createLucideIcon } from 'lucide-react';
export const ChevronLeft = createLucideIcon('chevron-left', [
  [
    'path',
    {
      d: 'M15 5L8 12L15 19',
      key: '1g7ffr',
    },
  ],
]);
